import axiosInstance from "@/config/axios";

// Services for Notification Management

export const getAllNotifications = async (params?: { [key: string]: string | number | boolean | undefined }) => {
    const response = await axiosInstance.get("/notifications", { params });
    return response.data;
}
export const getNotificationById = async (id: string) => {
    const response = await axiosInstance.get(`/notifications/${id}`);
    return response.data;
}
export const deleteNotification = async (id: string) => {
    const response = await axiosInstance.delete(`/notifications/${id}`);
    return response.data;
}
export const markNotificationAsRead = async (id: string) => {
    const response = await axiosInstance.patch(`/notifications/read/${id}`);
    return response.data;
}